import { ecsWebClient } from './ecsWebClient';
import { ecsClientSettings as ecs } from '../initializeAnalytics';
import { isFeatureEnabled } from 'owa-feature-flags';

export function isEcsDisabledEvent(eventName: string) {
    return owaSamplingOverrides()[0]?.disabledEventNames.includes(eventName);
}

export function isEcsDefaultSampledEvent(eventName: string) {
    return owaSamplingOverrides()[0]?.defaultSampledEventNames.includes(eventName);
}

export function isEcsUnsampledEvent(eventName: string) {
    return owaSamplingOverrides()[0]?.unsampledEventNames.includes(eventName);
}

function owaSamplingOverrides() {
    return isFeatureEnabled('an-log-unified')
        ? ecs?.logRateOverride?.logRates?.filter(x => x.clients.includes(ecsWebClient)) || []
        : [];
}
